window.onload = () => {
    const container = document.querySelector('.product-player');
    const audioContainer = document.querySelector('.product-player');
    const playtrack = document.querySelector('.player__audio');
    const playButton = playtrack.getAttribute('data-play');
    const pauseButton = playtrack.getAttribute('data-pause');
    let audioBlockMetafield = JSON.parse(audioContainer.dataset.tab_meta);

    let wavePlayers = [];
    let tabPosition;
    let trackCount = 0;
    //let productId = document.querySelector('.player__audio').dataset.product;

    const tabs = ['demos', 'instruments', 'drums', 'vocals', 'xtras'];

    tabs.forEach((tab, index) => {
        const tabMetaName = `dg_${tab}`;
        const tabMeta = audioBlockMetafield[tabMetaName];
        tabPosition = index;

        if (tabMeta === 'demos') {
            const tracksArr = tabMeta.split('~');
            let tabContainer = document.createElement('div');
            let waveHolder = document.createElement('div');

            tabContainer.setAttribute('data-position', tabPosition)
            index === 0 ? tabContainer.classList.add('player-tab', 'active-tab') : tabContainer.classList.add('player-tab');
            waveHolder.classList.add('wave-holder');

            const recordName = document.querySelector('.player__audio').getAttribute('data-record_name');
            let tabName;
            tab === 'demos' ? tabName = `Listen to ${recordName}` : tabName = tab;
            tabContainer.innerHTML = `<h4>${tabName}</h4>`;

            audioContainer.appendChild(tabContainer);
            tabContainer.appendChild(waveHolder);

            tracksArr.forEach((track, index) => {
                const trackData = track.split('*');
                const trackUrl = trackData[0];

                if (trackUrl) {
                    const tabCapital = tab.charAt(0).toUpperCase() + tab.slice(1);
                    const handle = recordName.replaceAll(' ', '_');

                    const sanitised = trackUrl
                        .split('/')
                        .pop()
                        .replace('.mp3', '')
                        .split(handle)[1]
                        .replaceAll('%2B', ' ')
                        .replaceAll(' - ', '')
                        .replace(tabCapital, '')
                        .replaceAll('_', ' ');

                    const audio = {};
                    audio.trackUrl = trackUrl;
                    audio.trackName = sanitised === '' ? index : sanitised;
                    audio.trackPosition = index;
                    audio.recordName = recordName;
                    audio.recordCover = audioContainer.getAttribute('data-record_cover');
                    audio.preload = 'none';
                    audio.type = tab;
                    buildTrack(audio, tabContainer);
                }
            });

            const viewMoreContainer = document.createElement('div');
            const viewMore = document.createElement('span');

            if (tracksArr.length > 3) {
                viewMoreContainer.classList.add('view-more-container');

                viewMore.textContent = 'View More';
                viewMore.classList.add('view-more');

                viewMoreContainer.appendChild(viewMore);
                tabContainer.appendChild(viewMoreContainer);
            }
        }
    });


    function buildTrack(audio, tabContainer) {
        let trackName = audio.trackName.replaceAll(' ', '');
        let waveItem;
        let playContainer = document.createElement('div');
        let waveContainer = document.createElement('div');

        playContainer.innerHTML = `<button class="play-container"><span class="play-track">${playButton}</span>
    <span class="pause-track">${pauseButton}</span> <span>${audio.recordName} - ${ trackName }</span></button>`
        playContainer.setAttribute('id', trackName);
        playContainer.classList.add('wave-container');

        waveItem = WaveSurfer.create({
            container: waveContainer,
            waveColor: 'rgb(255 255 255)',
            progressColor: 'rgb(42 42 42)',
            cursorColor: 'rgb(255 215 55)',
            barWidth: 3,
            barHeight: 1,
            barGap: 3,
            height: 100,
            backend: 'MediaElement',
            responsive: true,
            normalize: true,
        });

        playContainer.appendChild(waveContainer);
        tabContainer.querySelector('.wave-holder').appendChild(playContainer);
        waveContainer.setAttribute('track-url', audio.trackUrl);
        waveContainer.setAttribute('track-position', trackCount);
        waveContainer.classList.add('track-details');


        if (tabPosition === 0 && trackCount === 0) {
            waveItem.load(audio.trackUrl);
            waveItem.on('ready', function() {
                document.querySelector('.pdp-play__text').textContent = '';
                document.querySelector('.pdp-play').classList.remove('loading');
                wavePlayers[1].load(wavePlayers[1].container.getAttribute('track-url'));
                wavePlayers[2].load(wavePlayers[2].container.getAttribute('track-url'));
            });
        }


        wavePlayers.push(waveItem);

        playContainer.querySelector('.play-container').addEventListener('click', function (event) {
            event.stopPropagation();

            if ( waveItem.isReady ) {
                if ( waveItem.isPlaying() ) {
                    waveItem.pause();
                    playContainer.querySelector('.play-track').style.display = 'inline-block';
                    playContainer.querySelector('.pause-track').style.display = 'none';
                    return;
                }

                wavePlayers.forEach(function(wave) {
                    if ( wave.isPlaying() ) {
                        wave.pause();
                        let waveDiv = wave.mediaContainer.parentNode;
                        waveDiv.querySelector('.play-track').style.display = 'inline-block';
                        waveDiv.querySelector('.pause-track').style.display = 'none';
                    }
                });

                waveItem.play();
                playContainer.querySelector('.play-track').style.display = 'none';
                playContainer.querySelector('.pause-track').style.display = 'inline-block';
            }
        });

        document.querySelector('.wave-holder').style.setProperty('height', `${630}px`);
        trackCount += 1;
    }

    [...document.querySelectorAll('.player-tab')].forEach(function(element) {
        element.addEventListener('click', function(event) {
            event.stopPropagation(),

                [...document.querySelectorAll('.player-tab')].forEach(function(element) {
                    element.classList.remove('active-tab');
                    element.querySelector('.wave-holder').style.setProperty('height', `0px`);

                    if ( element.querySelector('.wave-holder').classList.contains('full-height') ) {
                        element.querySelector('.wave-holder').classList.remove('full-height');
                        element.querySelector('.view-more').textContent = 'View More';
                    }
                });


            let waveBlocks = element.querySelectorAll('.wave-container');

            [...waveBlocks].forEach(function(item, index){
                let wavePosition = ~~item.querySelector('.track-details').getAttribute('track-position');
                let waveTrack = item.querySelector('.track-details').getAttribute('track-url');

                if (!wavePlayers[wavePosition].isReady && index < 2) {
                    wavePlayers[wavePosition].load(waveTrack);
                }
            });

            element.classList.add('active-tab');

            let heightDrop = 0;
            element.querySelectorAll('.wave-container').forEach(function(element) {
                heightDrop += (element.offsetHeight + 40);
            });

            let expandSize = 0;
            if (heightDrop > 420) {
                expandSize = 630;
            } else {
                expandSize = heightDrop;
            }

            wavePlayers.forEach(function(wave) {
                if ( wave.isPlaying() ) {
                    wave.pause();
                    let waveDiv = wave.mediaContainer.parentNode;
                    waveDiv.querySelector('.play-track').style.display = 'inline-block';
                    waveDiv.querySelector('.pause-track').style.display = 'none';
                }
            });

            element.querySelector('.wave-holder').style.setProperty('height', `${expandSize}px`);
        });
    });


    document.querySelectorAll('.view-more').forEach(function(element) {
        element.addEventListener('click', function(event) {
            event.stopPropagation();
            let container = element.parentNode.parentNode.querySelector('.wave-holder');
            let waveBlocks = element.parentNode.parentNode.querySelectorAll('.wave-container');

            [...waveBlocks].forEach(function(item, index){
                let wavePosition = ~~item.querySelector('.track-details').getAttribute('track-position');
                let waveTrack = item.querySelector('.track-details').getAttribute('track-url');

                if (!wavePlayers[wavePosition].isReady && index > 1) {
                    wavePlayers[wavePosition].load(waveTrack);
                }
            });

            if (container.classList.contains('full-height')) {
                container.classList.remove('full-height');
                container.style.setProperty('height', `630px`);
                event.target.textContent = 'View More';
            } else {
                let containerHeight = 0;

                container.querySelectorAll('.wave-container').forEach(function(element) {
                    containerHeight += (element.offsetHeight + 25);
                });

                container.style.setProperty('height', `${containerHeight}px`);
                container.classList.add('full-height');
                event.target.textContent = 'View Less';
            }
        });
    });
    var pdpPlay = document.querySelector('.pdp-play');
    var playTrack = document.querySelector('.play-container');

    const productPlayer = document.querySelector('.product-player');

    pdpPlay.addEventListener('click', function () {
        playTrack.click();
        document.querySelector('.wave-holder').style.height = '120px';
        productPlayer.style.position = 'fixed';
        productPlayer.style.bottom = '-21px';
        productPlayer.classList.add('fixed');
        setTimeout(() => {
            productPlayer.style.transition = 'all 230ms ease-in-out';
        }, 100);
        setTimeout(() => {
            productPlayer.style.opacity = '1';
        }, 500);
    });

    const metafieldPlaylist = document.querySelector('.metafield-playlist');

    window.addEventListener('scroll', function() {
        if ((window.scrollY + 450) > metafieldPlaylist.offsetTop) {
            productPlayer.style.position = 'unset';
            productPlayer.classList.remove('fixed');
            document.querySelector('.wave-holder').style.height = '630px';
        }
    });
};
